(() => {
  const PORTAL_ID = 'elb-portal';
  const OFFSET = 14;       // horizontaler Abstand zum Cursor
  const MARGIN = 8;        // Sicherheitsrand zum Viewport

  let overlayEl = null;
  let currentTarget = null;
  let isTouchOpen = false;

  // Merkt sich die letzte Cursor-Position (für Re-Positionierung nach Bild-Load)
  let lastClientX = null;
  let lastClientY = null;

  function ensurePortal() {
    let portal = document.getElementById(PORTAL_ID);
    if (!portal) {
      portal = document.createElement('div');
      portal.id = PORTAL_ID;
      portal.setAttribute('aria-hidden', 'true');
      document.body.appendChild(portal);
    }
    return portal;
  }

  function createOverlay() {
    if (overlayEl) return overlayEl;
    overlayEl = document.createElement('div');
    overlayEl.className = 'elb-overlay';
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-label', 'Energielabel');
    ensurePortal().appendChild(overlayEl);
    return overlayEl;
  }

  function loadLabelIntoOverlay(url) {
    const el = createOverlay();
    el.innerHTML = ''; // reset
    const img = document.createElement('img');
    img.alt = 'Energielabel';
    img.loading = 'eager'; // laden erst bei Interaktion
    img.src = url;

    // Nach Bild-Load erneut exakt zentrieren (falls Größe sich geändert hat)
    img.onload = () => {
      if (lastClientX != null && lastClientY != null) {
        positionOverlay(lastClientX, lastClientY);
      }
    };

    el.appendChild(img);
  }

  // Zentrum des Overlays auf Cursorhöhe (vertikal), rechts/links flippen bei Platzmangel
  function clampPosition(x, y) {
    const el = overlayEl;
    if (!el) return { x, y };

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const rect = el.getBoundingClientRect();

    // Vertikal: Cursorhöhe = Mitte des Overlays
    let ny = y - rect.height / 2;
    // Clamping an die Viewport-Ränder
    ny = Math.min(Math.max(MARGIN, ny), vh - rect.height - MARGIN);

    // Standard: rechts vom Cursor
    let nx = x + OFFSET;

    // Wenn rechts kein Platz -> nach links flippen
    if (nx + rect.width + MARGIN > vw) {
      nx = x - rect.width - OFFSET;
      // Falls links auch nicht genug Platz, so weit wie möglich innerhalb des Viewports
      if (nx < MARGIN) {
        nx = Math.max(MARGIN, vw - rect.width - MARGIN);
      }
    }

    // Sicherheit: auch rechts clampen
    nx = Math.min(Math.max(MARGIN, nx), vw - rect.width - MARGIN);

    return { x: nx, y: ny };
  }

  function positionOverlay(clientX, clientY) {
    if (!overlayEl) return;
    const pos = clampPosition(clientX, clientY);
    overlayEl.style.left = `${pos.x}px`;
    overlayEl.style.top  = `${pos.y}px`;
  }

  function openOverlay(target, clientX, clientY, interactive = false) {
    const root = target.closest('.elb');
    if (!root) return;
    const labelUrl = root.getAttribute('data-elb-label');
    if (!labelUrl) return;

    loadLabelIntoOverlay(labelUrl);
    overlayEl.classList.toggle('is-interactive', !!interactive);
    overlayEl.style.opacity = '0';
    overlayEl.style.position = 'fixed';
    overlayEl.style.left = '0px';
    overlayEl.style.top  = '0px';
    overlayEl.style.transition = 'opacity .12s ease-out';
    overlayEl.style.willChange = 'transform';

    // letzte Position merken (für Repositionierung)
    lastClientX = clientX;
    lastClientY = clientY;

    // Nach Einfügen einmal sauber positionieren & einblenden
    requestAnimationFrame(() => {
      positionOverlay(clientX, clientY);
      overlayEl.style.opacity = '1';
    });
  }

  function closeOverlay() {
    if (!overlayEl) return;
    overlayEl.style.opacity = '0';
    setTimeout(() => {
      if (overlayEl) overlayEl.innerHTML = '';
    }, 120);
    isTouchOpen = false;
    currentTarget = null;
  }

  // ===== Desktop: Hover am Icon =====
  document.addEventListener('mouseover', (e) => {
    const iconBtn = e.target.closest && e.target.closest('.elb-icon');
    if (!iconBtn) return;
    if (isTouchOpen) return; // Touch-Mode gerade aktiv -> Desktop-Hover ignorieren
    currentTarget = iconBtn;
    lastClientX = e.clientX;
    lastClientY = e.clientY;
    openOverlay(iconBtn, e.clientX, e.clientY, false);
  });

  document.addEventListener('mousemove', (e) => {
    if (!currentTarget || !overlayEl) return;
    lastClientX = e.clientX;
    lastClientY = e.clientY;
    positionOverlay(e.clientX, e.clientY);
  });

  document.addEventListener('mouseout', (e) => {
    if (!currentTarget) return;
    const toEl = e.relatedTarget;
    const stillInside = toEl && (toEl === currentTarget || toEl.closest('.elb-icon') === currentTarget);
    if (stillInside) return;
    if (!isTouchOpen) closeOverlay();
  });

  // ESC schließt
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeOverlay();
  });

  // ===== Mobile/Touch: Tap-to-toggle =====
  document.addEventListener('pointerdown', (e) => {
    const iconBtn = e.target.closest && e.target.closest('.elb-icon');
    const overlayClicked = e.target.closest && e.target.closest('.elb-overlay');
    if (iconBtn) {
      e.preventDefault();
      const isOpen = isTouchOpen && currentTarget === iconBtn;
      if (isOpen) {
        closeOverlay();
        return;
      }
      currentTarget = iconBtn;
      isTouchOpen = true;

      const rect = iconBtn.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;

      lastClientX = cx;
      lastClientY = cy;

      openOverlay(iconBtn, cx, cy, true);
      return;
    }
    // Tap außerhalb: schließen
    if (!overlayClicked) {
      closeOverlay();
    }
  }, { passive: false });

  // Bei Resize/Scroll schließen (verhindert „hängende“ Positionen)
  window.addEventListener('scroll', () => { if (!isTouchOpen) closeOverlay(); }, { passive: true });
  window.addEventListener('resize', () => closeOverlay(), { passive: true });
})();
